import React, { useEffect } from "react";
import { Tooltip, Typography } from "@mui/material";
import { ReactComponent as Reste } from "../img/icons/le reste.svg";

function Usr_Caisse({ small }) {
    const Gfunc = require("../Gfunc.js");
    useEffect(() => {

        Gfunc.fetchCaisse(localStorage.getItem("uid"));

    }, [Gfunc]);

    const handleCaisse = () => {
        Gfunc.fetchCaisse(localStorage.getItem("uid"));
    };

    return (
        <Tooltip title="Cliquer pour actualiser la caisse" disableInteractive>
            {(!small) ?
                <div style={{ right: "0", minWidth: "120px", position: "fixed", top: "45px", display: "flex", alignItems: "center", width: "fit-content", height: "fit-content", cursor: "pointer", background: "var(--primary-main)", padding: "0px 8px", paddingRight: "16px", borderRadius: "0 0 0px 10px" }} onClick={handleCaisse} >
                    {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%", cursor: "pointer" }} onClick={handleCaisse} > */}
                    {/* <Tooltip title="Balance" arrow disableInteractive><Reste style={{ width: "18px", height: "18px", fill: "var(--primary-dark)", marginTop: "4px", marginRight: "8px" }} /></Tooltip>
            <Typography id="userBalance" style={{ fontSize: "12px !important", color: "var(--primary-dark)" }}>
            </Typography> */}
                    <Reste style={{ width: "16px", height: "16px", fill: "white", marginTop: "4px", marginRight: "8px", }} />
                    <Typography id="userBalance" style={{ color: "white", marginLeft: "auto" }} fontSize={"12px"} fontWeight={"600"}>
            </Typography>
                </div> : <div style={{ left: "50%", minWidth: "120px", position: "fixed", transform: "translateX(-50%)", top: "45px", display: "flex", alignItems: "center", width: "fit-content", height: "fit-content", cursor: "pointer", background: "var(--primary-main)", padding: "0px 8px", borderRadius: "0 0 10px 10px" }} onClick={handleCaisse} >
                    <Reste style={{ width: "16px", height: "16px", fill: "white", marginTop: "4px", marginRight: "8px", }} />
                    <Typography id="userBalance" style={{ color: "white", margin: "auto" }} fontSize={"11px"}>
            </Typography>
                </div>}
        </Tooltip>
    );
}

export default React.memo(Usr_Caisse);
